/*globals debounce*/
// Scroll detection
(function scrollState($) {
    var $doc = $(document),
        $body = $('body'),
        $header = $('.main section:first-of-type');

    if (!$header.length) {
        return;
    }

    var threshold = $header.offset().top + $header.outerHeight()/6,
        className = 'is-scrolled';

    // back-to-top needs a different scroll threshold
    var thresholdMore = $(window).height()/2,
        classNameMore = 'is-scrolled-more';

    // Set the scroll state for .is-scrolled based on passed threshold
    // from the top of the page
    var setScroll = debounce(function(){
        var scroll = $doc.scrollTop();

        if (scroll >= threshold) {
            $body.addClass(className);
        } else {
            $body.removeClass(className);
        }

        if (scroll >= thresholdMore) {
            $body.addClass(classNameMore);
        } else {
            $body.removeClass(classNameMore);
        }

    }, 50);

    $(window).on('scroll.body', setScroll);
    setScroll();
}(jQuery));
